import get from 'lodash/get';

// FIXME: this will likely need to be more robust once we start supporting translations.
export const isFeatured = winner => {
  const winnerStoryRecord = get(winner, 'winnerStoryRecords', []).find(({lang}) => lang === winner.lang);
  return winnerStoryRecord ? winnerStoryRecord.isFeatured : winner.isFeatured;
};



// WEBPACK FOOTER //
// ./public/pages/ListWinners/utils.js